module.exports = __webpack_public_path__ + "images/2a3e28b5b69fd5792812c77aff3a3945.svg";